import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { fetch } from '@ngrx/router-store/data-persistence';
import { map } from 'rxjs/operators';

import { LastViewedArticlesService } from '../services';

import { LastViewedArticlesActions } from './last-viewed-articles.actions';

@Injectable()
export class LastViewedArticlesEffects {
  fetchLastViewedArticles$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(LastViewedArticlesActions.fetchLastViewedArticles),
      fetch({
        run: () => {
          return this.lastViewedArticlesService
            .fetchLastViewedArticles()
            .pipe(
              map((lastViewedArticles) =>
                LastViewedArticlesActions.fetchLastViewedArticlesSuccess({ lastViewedArticles }),
              ),
            );
        },
        onError: () => LastViewedArticlesActions.fetchLastViewedArticlesError(),
      }),
    );
  });

  markArticleAsViewed$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(LastViewedArticlesActions.markArticleAsViewed),
      fetch({
        id: ({ globalArticleId }) => globalArticleId,
        run: ({ globalArticleId }) => {
          return this.lastViewedArticlesService
            .markArticleAsViewed(globalArticleId)
            .pipe(map(() => LastViewedArticlesActions.markArticleAsViewedSuccess()));
        },
        onError: () => LastViewedArticlesActions.markArticleAsViewedError(),
      }),
    );
  });

  constructor(
    private readonly actions$: Actions,
    private readonly lastViewedArticlesService: LastViewedArticlesService,
  ) {}
}
